import { createRoot } from "react-dom/client";
import LandingPage from "./pages/LandingPage";
import "./index.css";

createRoot(document.getElementById("root")!).render(<LandingPage />);
